// export const capitalizeFirstLetter = (input: string) => {
//   if (typeof input !== 'string') {
//     throw new Error('Input must be a string');
//   }

//   if (input.length === 0) {
//     return input;
//   }

//   const stringWithSpaces = input.replace(/_/g, ' ');

//   return (
//     stringWithSpaces.charAt(0).toUpperCase() +
//     stringWithSpaces.slice(1).toLowerCase()
//   );
// };

export const capitalizeFirstLetter = (input: string) => {
  if (typeof input !== 'string') {
    throw new Error('Input must be a string');
  }

  if (input.length === 0) {
    return input;
  }

  const stringWithSpaces = input.replace(/_/g, ' ');

  return stringWithSpaces
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};
